import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const EpTableDropdownOptions = ({ ariaLabelledby, contentDropdown }) => (
  <div className="dropdown-menu dropdown__menu-options" aria-labelledby={ariaLabelledby}>
    {contentDropdown}
  </div>
);

export default EpTableDropdownOptions;

EpTableDropdownOptions.propTypes = {
  ariaLabelledby: PropTypes.string.isRequired,
  contentDropdown: PropTypes.element.isRequired,
};
